import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { streetsRoutes } from './streets.routing'
import { UpdateStreetComponent } from './update-street/update-street.component'
import { CreateStreetComponent } from './create-street/create-street.component'
import { StreetsComponent } from './streets.component'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from 'src/app/shared/shared.module'
import { BreadcrumbsModule } from '@components/breadcrumbs/breadcrumbs.module'

@NgModule({
  declarations: [
    StreetsComponent,
    CreateStreetComponent,
    UpdateStreetComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(streetsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
    BreadcrumbsModule,
  ],
  exports: [StreetsComponent, CreateStreetComponent, UpdateStreetComponent],
})
export class StreetsModule {}
